import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'services-section';
const BLOCK_ID = 'services-section';
const PLACEHOLDER_LABEL = 'Leistungen';

export default function servicesSection(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-services-section') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }

            return undefined;
        },

        model: {
            defaults: {
                tagName: 'div',
                name: 'Leistungen',
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-services',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [
                    {
                        type: 'checkbox',
                        label: 'Im Akkordeon anzeigen',
                        name: 'showInAccordion',
                        valueTrue: true,
                        valueFalse: false,
                        default: false,
                        changeProp: 1,
                    },
                ],
            },
        },

        view: {},
    });

    blockManager.add(BLOCK_ID, {
        label: 'Leistungen',
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2Zm-10-2h4v2h-4V4Zm10 14H4V8h16v10Zm-7-7h-2v-2h2v2Zm0 4h-2v-2h2v2Z"/>
        </svg>`,

        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-services',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
